import { FC, useEffect } from 'react';

import { useVideoContext } from '../../VideoController/VideoController.context';

import ContentGenerator from '../../../Shared/ContentGenerator';

import { Content } from '../../../../types/tour';

export type Props = {
  content: Content;
  setComplete: () => void;
  goNext: () => void;
  step: number;
};

export const Step7: FC<Props> = ({ setComplete, content }) => {
  const { state } = useVideoContext();

  useEffect(() => {
    const run = async () => {
      const { call } = state;
      await call.endCall();
    };
    setComplete();
    run();
  }, []);

  return <ContentGenerator content={content} />;
};
